var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 187,
    height: 227,
    viewBox: "0 0 187 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9481",
    "data-name": "Rectangle 9481",
    width: 48,
    height: 53,
    transform: "translate(0 0.061)",
    fill: "#7b8991"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11072",
    "data-name": "Group 11072",
    transform: "translate(-538 -2273.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9483",
    "data-name": "Rectangle 9483",
    d: "M10,0H187a0,0,0,0,1,0,0V227a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(538 2273.296)",
    fill: "#e9edef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11071",
    "data-name": "Group 11071",
    transform: "translate(214 -24.602)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "IMAGEN_NO_DISPONIBLE",
    "data-name": "IMAGEN NO DISPONIBLE",
    transform: "translate(358.203 2419.549)",
    fill: "#7b8991",
    fontSize: 20,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "IMAGEN NO "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44
  }, "DISPONIBLE")), /*#__PURE__*/React.createElement("g", {
    id: "Group_11069",
    "data-name": "Group 11069",
    transform: "translate(392 2342.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11067",
    "data-name": "Group 11067",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24123",
    "data-name": "Path 24123",
    d: "M23.877,10A23.778,23.778,0,0,0,0,33.877,2.507,2.507,0,0,0,2.653,36.53H45.1a2.507,2.507,0,0,0,2.653-2.653A23.778,23.778,0,0,0,23.877,10M5.571,31.224a18.485,18.485,0,0,1,36.612,0Z",
    transform: "translate(0 16.53)",
    fill: "#7b8991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24124",
    "data-name": "Path 24124",
    d: "M16.439,23.877A11.939,11.939,0,1,0,4.5,11.939,11.889,11.889,0,0,0,16.439,23.877m0-18.571a6.568,6.568,0,0,1,6.633,6.633,6.633,6.633,0,1,1-13.265,0,6.568,6.568,0,0,1,6.633-6.633",
    transform: "translate(7.439)",
    fill: "#7b8991"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.4ef42a841148bf584caf4394a1d6851b.svg";
export { ForwardRef as ReactComponent };